/*jslint node: true */
/*globals window, dataLayer, document */

import 'babel-polyfill';
import Vue from 'vue';
import VueRouter from 'vue-router';
import Login from './app/components/Login.vue';
import TopNav from './app/components/TopNav.vue';
import SideNav from './app/components/SideNav.vue';
import Contest from './app/components/Contest.vue';
import App from './app/components/App.vue';
import store from './app/store';
import routes from './app/modules/routes.js';
import analytics from './app/modules/analytics.js';
import moment from 'moment';

Vue.prototype.moment = moment;
Vue.prototype.analytics = analytics;
Vue.prototype.formatNumber = function (val) {
  if (!val) return '';

  return val.toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
};

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  base: '/oma-hedin-automotive/',
  routes: routes.routes
});

Vue.component('login-component', Login);
Vue.component('topnav-component', TopNav);
Vue.component('sidenav-component', SideNav);
Vue.component('contest', Contest);
Vue.component('app', App);

new Vue({
  el: '#root',
  router,
  store,
  watch: {
    $route: function (value) {
      let section = typeof this.$route.params.section !== 'undefined' ? this.$route.params.section : false;
      var dataLayerObj = {
        'event': 'GAVirtualPage',
        'eventCategory': 'OmaLaakkonen',
        'eventAction': 'PageLoad',
        'eventLabel': '/omalaakkonen' + this.$route.path + '/',
        'eventNonInteraction': 'false'
      };
      dataLayer.push(dataLayerObj);
      //console.log('scroll init!!');
      //console.log({ scroll : this.$store.state.scroll, section : section });
      if (!section) window.scrollTo(0, 0);
      else if (this.$store.state.scroll && section) {
        setTimeout(function () {

          let el = document.getElementById(section);
          window.scrollTo(0, el.offsetTop);
        }, 500);
      }
    }
  }
});
